const texts = {
  title: 'Instructions',
  addInstruction: 'Add Instruction',
};

export default texts;
